( function () {
	'use strict';

	/**
	 * Show that filtered products are loading.
	 *
	 * Filters, removable chips and pagination update the catalogue in place
	 * through the Interactivity API router, which leaves the old products on
	 * screen until the server responds. Fade them immediately so visitors see
	 * the click was received, and clear the fade when the results change. The
	 * router records the new URL (history.pushState/replaceState) when it has
	 * finished, which also clears the fade when the new results are identical.
	 */
	var root = document.documentElement;
	var className = 'folis-catalog-loading';
	var regionSelector = '[data-wp-router-region^="wc-product-collection"]';
	var triggers = [
		'.wp-block-woocommerce-product-filters input',
		'.wp-block-woocommerce-product-filters button',
		'.wp-block-woocommerce-product-filter-removable-chips button',
		'.wp-block-query-pagination a',
	].join( ',' );
	var overlayControls = '.wc-block-product-filters__open-overlay, .wc-block-product-filters__close-overlay, .wc-block-product-filters__overlay-header';
	var timer = null;
	var observer = null;
	var signature = '';

	if ( ! document.querySelector( regionSelector ) ) {
		return;
	}

	function currentSignature() {
		var region = document.querySelector( regionSelector );
		if ( ! region ) {
			return '';
		}
		var keys = Array.prototype.map.call( region.querySelectorAll( '[data-wp-key^="product-item-"]' ), function ( item ) {
			return item.getAttribute( 'data-wp-key' );
		} );
		var count = document.querySelector( '.wp-block-woocommerce-product-results-count' );
		return keys.join( ',' ) + '|' + ( count ? count.textContent : '' );
	}

	function stop() {
		window.clearTimeout( timer );
		if ( observer ) {
			observer.disconnect();
			observer = null;
		}
		root.classList.remove( className );
	}

	function start() {
		if ( root.classList.contains( className ) ) {
			return;
		}
		signature = currentSignature();
		root.classList.add( className );
		observer = new MutationObserver( function () {
			if ( currentSignature() !== signature ) {
				stop();
			}
		} );
		observer.observe( document.querySelector( regionSelector ).parentNode, { childList: true, subtree: true, characterData: true } );
		// Never leave the grid faded if a navigation fails.
		timer = window.setTimeout( stop, 10000 );
	}

	[ 'pushState', 'replaceState' ].forEach( function ( method ) {
		var original = window.history[ method ];
		window.history[ method ] = function () {
			var result = original.apply( this, arguments );
			if ( root.classList.contains( className ) ) {
				window.clearTimeout( timer );
				timer = window.setTimeout( stop, 150 );
			}
			return result;
		};
	} );
	window.addEventListener( 'popstate', stop );

	document.addEventListener( 'click', function ( event ) {
		var target = event.target.closest && event.target.closest( triggers );
		if ( ! target || target.closest( overlayControls ) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ) {
			return;
		}
		start();
	} );
	document.addEventListener( 'change', function ( event ) {
		if ( event.target.matches && event.target.matches( triggers ) ) {
			start();
		}
	} );
}() );
